import { isFinite, sum } from 'lodash';

export function formatNumberToUnits(number, decimalPlacesForUnit = 0, decimalPlacesForNumber = 0, trimZeros = false) {
  if (!isFinite(number)) return null;

  const units = ['K', 'M', 'B'];
  let decimal;

  for (let i = units.length - 1; i >= 0; i--) {
    decimal = Math.pow(1000, i + 1);

    if (Math.abs(number) >= decimal) {
      const raw = (number / decimal).toFixed(decimalPlacesForUnit);
      const value = trimZeros && decimalPlacesForUnit > 0 ? _trimTrailingZeros(raw) : raw;
      return value + units[i];
    }
  }

  const rawNumber = number.toFixed(decimalPlacesForNumber);
  return trimZeros && decimalPlacesForNumber > 0 ? _trimTrailingZeros(rawNumber) : rawNumber;
}

// Examples: "1.0" -> "1", "2.500" -> "2.5", "3." -> "3"
function _trimTrailingZeros(str) {
  return str.replace(/(\.\d*?[1-9])0+$|\.0*$/, '$1');
}

export function roundPercents(percents) {
  if (!sum(percents)) return percents;
  const sortedByDecimal = [];
  for (let i = 0; i < percents.length; i++) {
    const percentWithIndex = {};
    percentWithIndex[percents[i]] = i;
    sortedByDecimal.push(percentWithIndex);
  }
  sortedByDecimal.sort(function (a, b) {
    const aDecimal = Object.keys(a)[0];
    const bDecimal = Object.keys(b)[0];
    return aDecimal - Math.floor(aDecimal) > bDecimal - Math.floor(bDecimal) ? -1 : 1;
  });
  const indexOfPercentsSortedByDecimal = sortedByDecimal.map((d) => d[Object.keys(d)[0]]);
  percents = percents.map((n) => Math.floor(n));
  const missingTo100 = 100 - percents.reduce((a, b) => a + b);
  for (let j = 0; j < missingTo100; j++) {
    percents[indexOfPercentsSortedByDecimal[j]] += 1;
  }
  return percents;
}

export function convertStringToFloat(str) {
  const floatValue = parseFloat(str);
  return isNaN(floatValue) ? str : floatValue;
}

/**
 * Format number with K/M/B notation
 * Billions always show at least 1 decimal place
 * @param {number|string} value - Value to format
 * @param {number} decimals - Number of decimal places (default 0)
 * @returns {string} Formatted number (e.g., "1M", "1.2B", "500K")
 */
export function formatShortNumber(value, decimals = 0) {
  if (value === null || value === undefined || value === '') return '';
  const num = typeof value === 'number' ? value : convertStringToFloat(value);
  if (isNaN(num)) return value;

  const abs = Math.abs(num);
  if (abs >= 1000000000) {
    // Always use at least 1 decimal place for billions
    const billionDecimals = Math.max(decimals, 1);
    return (num / 1000000000).toFixed(billionDecimals) + 'B';
  }
  if (abs >= 1000000) {
    return (num / 1000000).toFixed(decimals) + 'M';
  }
  if (abs >= 1000) {
    return (num / 1000).toFixed(decimals) + 'K';
  }
  return num.toFixed(decimals);
}
